export default {
    header: 'EFMD Virtual Fair',
    activeNow: 'Ongoing',
    visibilityPrivate: 'Private',
    visibilityNetwork: 'Network',
    visibilityOpen: 'Open',
    interested: 'Confirm your interest',
    attend: 'Attend the fair',
    notinterested: 'I am not interested anymore',
    showninterest: 'We will notify when it starts',
    signUpToday: 'Sign up today!',
    vfairsInfo:
        'Connect with companies and organisations from around the globe, in a sophisticated job fair simulation environment that enables real-time interaction between recruiters and candidates. Click on the fair you are interested in and sign up to receive notifications.',
    recruitingOrgs: 'Recruiting Companies & Organisations',
    preRegistered: 'Pre-registered',
    prepareForTheFair: 'Prepare for the fair',
    links: {
        masterclasses: {
            header: 'Masterclasses',
            buttonCaption: 'Watch the Masterclasses',
            description:
                'View a wide array of top-quality masterclasses including “CV Optimization to Get Hired”, “Rock Your Linkedin Profile” and “Salary Negotiation”, amongst many others, for all stages of your career trajectory!',
        },
        detailsmasterclass: {
            header: 'Attend the masterclass',
        },
        cv: {
            header: 'CV Template',
            buttonCaption: 'Download CV Template',
            description:
                'Access the Highered ATS-friendly CV template in order to make an optimal professional impression with recruiters.',
        },
        elevatorPitch: {
            header: 'Elevator Pitch Challenge ',
            buttonCaption: 'Send your pitch',
            description:
                'Take the “Pitch Perfect Challenge”! This is your opportunity to pitch your value to hundreds of recruiters from top global companies and organisatons!',
        },
    },
    footerHeaders: {
        social: 'Follow us for more updates',
        sponsored: 'Sponsored by',
        organized: 'Organized by',
    },
};
